import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { BsChevronDown } from 'react-icons/bs';
import Timeline from '../Timeline/Timeline';
import './TimelineIntro.scss';
import { formatParagraphs } from '../../../models/Utils';
import { ADAARIARoles, ADALandmarks, ADAWidgitRoles } from '../../../models/ADA';

const TimelineIntro = ({ content, goToNextSlide, goToPrevSlide, isActive, timelineIndex }) => {
  const [timelineExpanded, setTimelineExpanded] = useState(false);
  const menuOpened = useSelector(state => state.data.menuOpened);
  const onBeginClicked = () => {
    setTimelineExpanded(true);
  };
  useEffect(() => {
    if (!isActive) {
      setTimeout(() => {
        setTimelineExpanded(false);
      }, 500);
    }
  }, [isActive]);

  return timelineExpanded ? (
    <Timeline
      goToNextSlide={goToNextSlide}
      goToPrevSlide={goToPrevSlide}
      isActive={isActive}
      timelineIndex={timelineIndex}
    />
  ) : (
    <div className="timeline-intro">
      <div className="content">
          <h2 role={ADAARIARoles.Heading}>{content && content.Header}</h2>
        <div aria-hidden={true} className="body">{content && formatParagraphs(content.Body)}</div>
        <button role={ADAWidgitRoles.Button} tabIndex={isActive ? 0 : -1} onClick={onBeginClicked}>Begin</button>
      </div>
    </div>
  );
};

export default TimelineIntro;
